/*!
 *
 *   @bornfight/gocart v1.0.9
 *
 *
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 *
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *	Add Multiple Triggers
 *
 */

 class GoCart {
  constructor(options) {
    const defaults = {
      cartModalFail: ".js-go-cart-modal-fail",
      cartModalFailClose: ".js-go-cart-modal-fail-close",
      cartModal: ".js-go-cart-modal",
      cartModalClose: ".js-go-cart-modal-close",
      cartModalContent: ".js-go-cart-modal-content",
      cartModalItems: ".go-cart-item__single",
      cartDrawer: ".js-go-cart-drawer",
      cartDrawerContent: ".js-go-cart-drawer-content",
      cartDrawerContentNotes: ".js-go-cart-drawer-content-cart-notes",
      cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
      cartDrawerFooter: ".js-go-cart-drawer-footer",
      cartDrawerClose: ".js-go-cart-drawer-close",
      cartMiniCart: ".js-go-cart-mini-cart",
      cartMiniCartContent: ".js-go-cart-mini-cart-content",
      cartMiniCartSubTotal: ".js-go-cart-mini-cart-subtotal",
      cartMiniCartFooter: ".js-go-cart-mini-cart-footer",
      cartTrigger: ".js-go-cart-trigger",
      cartOverlay: ".js-go-cart-overlay",
      cartCount: ".js-go-cart-counter",
      addToCart: ".js-go-cart-add-to-cart",
      removeFromCart: ".js-go-cart-remove-from-cart",
      removeFromCartNoDot: "js-go-cart-remove-from-cart",
      itemQuantity: ".js-go-cart-quantity",
      itemQuantityPlus: ".js-go-cart-quantity-plus",
      itemQuantityMinus: ".js-go-cart-quantity-minus",
      cartMode: "drawer",
      drawerDirection: "right",
      displayModal: false,
      // eslint-disable-next-line no-template-curly-in-string
      moneyFormat: "${{amount}}",
      labelAddedToCart: "was added to your cart.",
      labelCartIsEmpty: "Your Cart is currently empty!",
      labelQuantity: "Quantity:",
      labelRemove: "Remove",
      hiddenItemTag: "hidden-product",
      annouments: ".go-cart-drawer .annoument",
      cartNotes: false,
    };

    this.defaults = Object.assign({}, defaults, options);

    this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
    this.cartModalFailClose = document.querySelector(
      this.defaults.cartModalFailClose
    );
    this.cartModal = document.querySelector(this.defaults.cartModal);
    this.cartModalClose = document.querySelectorAll(
      this.defaults.cartModalClose
    );
    this.cartModalContent = document.querySelector(
      this.defaults.cartModalContent
    );
    this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
    this.cartDrawerContent = document.querySelector(
      this.defaults.cartDrawerContent
    );
    this.cartDrawerContentNotes = document.querySelector(
      this.defaults.cartDrawerContentNotes
    );
    this.cartDrawerSubTotal = document.querySelector(
      this.defaults.cartDrawerSubTotal
    );
    this.cartDrawerFooter = document.querySelector(
      this.defaults.cartDrawerFooter
    );
    this.cartDrawerClose = document.querySelector(
      this.defaults.cartDrawerClose
    );
    this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
    this.cartMiniCartContent = document.querySelector(
      this.defaults.cartMiniCartContent
    );
    this.cartMiniCartSubTotal = document.querySelector(
      this.defaults.cartMiniCartSubTotal
    );
    this.cartMiniCartFooter = document.querySelector(
      this.defaults.cartMiniCartFooter
    );
    this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
    this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
    // this.cartCount = document.querySelector(this.defaults.cartCount);
    this.cartCount = document.querySelectorAll(this.defaults.cartCount);
    this.addToCart = document.querySelectorAll(this.defaults.addToCart);
    this.removeFromCart = this.defaults.removeFromCart;
    this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
    this.itemQuantity = this.defaults.itemQuantity;
    this.itemQuantityPlus = this.defaults.itemQuantityPlus;
    this.itemQuantityMinus = this.defaults.itemQuantityMinus;
    this.cartMode = this.defaults.cartMode;
    this.drawerDirection = this.defaults.drawerDirection;
    this.displayModal = this.defaults.displayModal;
    this.moneyFormat = this.defaults.moneyFormat;
    this.labelAddedToCart = this.defaults.labelAddedToCart;
    this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
    this.labelQuantity = this.defaults.labelQuantity;
    this.labelRemove = this.defaults.labelRemove;
    this.hiddenItemTag = this.defaults.hiddenItemTag;
    this.cartNotes = this.defaults.cartNotes;
    this.annoumentsBar = document.querySelector(this.defaults.annouments);

    this.init();
  }

  get isDrawerMode() {
    return this.cartMode === "drawer";
  }

  init() {
    this.fetchCart();

    if (this.isDrawerMode) {
      this.setDrawerDirection();
    }

    /*
        document.addEventListener('click', (event) => {
            if (event.target.matches(this.defaults.addToCart)) {
                event.preventDefault();
                let item = event.target;
                let form = item.parentNode;
                while ('form' !== form.tagName.toLowerCase()) {
                    form = form.parentNode;
                }
                const formID = form.getAttribute('id');
                this.addItemToCart(formID);
            }
        }, false);
        */
    if (this.addToCart) {
      this.addToCart.forEach((item) => {
        item.addEventListener("click", (event) => {
          event.preventDefault();
          let form = item.parentNode;
          while ("form" !== form.tagName.toLowerCase()) {
            form = form.parentNode;
          }
          const formID = form.getAttribute("id");
          this.addItemToCart(formID);
        });
      });
    }

    this.cartTrigger.forEach((item) => {
      item.addEventListener("click", () => {
        if (this.isDrawerMode) {
          this.openCartDrawer();
        } else {
          this.openMiniCart();
        }
        this.openCartOverlay();
      });
    });
    this.cartOverlay.addEventListener("click", () => {
      this.closeFailModal();
      this.closeCartModal();
      if (this.isDrawerMode) {
        this.closeCartDrawer();
      } else {
        this.closeMiniCart();
      }
      this.closeCartOverlay();
    });

    if (this.isDrawerMode) {
      this.cartDrawerClose.addEventListener("click", () => {
        this.closeCartDrawer();
        this.closeCartOverlay();
      });
    }

    if (this.displayModal) {
      this.cartModalClose.forEach((item) => {
        item.addEventListener("click", () => {
          this.closeFailModal();
          this.closeCartModal();
          if (this.isDrawerMode) {
            this.closeCartDrawer();
          } else {
            this.closeMiniCart();
          }
          this.closeCartOverlay();
        });
      });
    }

    this.cartModalFailClose.addEventListener("click", () => {
      this.closeFailModal();
      this.closeCartModal();
      if (this.isDrawerMode) {
        this.closeCartDrawer();
      } else {
        this.closeMiniCart();
      }
      this.closeCartOverlay();
    });
  }

  fetchCart(callback) {
    window
      .fetch("/cart?view=json", {
        credentials: "same-origin",
        method: "GET",
      })
      .then((response) => response.text())
      .then((cart) => {
        eval(cart);
        this.fetchHandler(window.cart, callback);
      })
      .catch((error) => {
        this.ajaxRequestFail();
        throw new Error(error);
      });
  }

  addItemToCart(formID) {
    const form = document.querySelector(`#${formID}`);
    const formData = serialize(form, { hash: true });
    var disable_add = false;
    if (formData.selling_plan != null && formData.selling_plan > 0) {
      let _splinter =
        formData.dsbrchge != null ? formData.dsbrchge.split("%") : null;

      if (_splinter != null) {
        _splinter.forEach((value) => {
          if (!disable_add) {
            disable_add = value == formData.id;
            return false;
          }
        });
      }
    }

    if (!disable_add) {
      window
        .fetch("/cart/add.js", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((product) => this.addItemToCartHandler(product))
        .catch((error) => {
          this.ajaxRequestFail();
          throw new Error(error);
        });
    }
  }

  updateCartOrderNote(element) {
    const cartNote = element.parentNode.querySelector(`[name="note"]`).value;

    window
      .fetch("/cart/update.js", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          note: cartNote,
        }),
      })
      .then((response) => response.json())
      .then(() => this.fetchCart())
      .catch((error) => {
        this.ajaxRequestFail();
        throw new Error(error);
      });
  }

  removeItem(line) {
    const quantity = 0;
    window
      .fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({ quantity, line }),
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.json())
      .then(() => this.fetchCart())
      .catch((error) => {
        this.ajaxRequestFail();
        throw new Error(error);
      });
  }

  changeItemQuantity(line, quantity) {
    window
      .fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({ quantity, line }),
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.json())
      .then(() => this.fetchCart())
      .catch((error) => {
        this.ajaxRequestFail();
        throw new Error(error);
      });
  }

  cartItemCount(cart) {
    // this.cartCount.innerHTML = cart.item_count;
    this.cartCount.forEach((item) => {
      item.innerHTML = cart.item_count;
    });
  }

  fetchAndOpenCart() {
    this.fetchCart(() => {
      if (this.isDrawerMode) {
        this.openCartDrawer();
        this.focusFirstItem();
      } else {
        this.openMiniCart();
      }
      this.openCartOverlay();
    });
  }

  fetchAndOpenModal(product) {
    this.fetchCart(() => {
      this.renderCartModal(product);
      this.openCartModal();
      this.openCartOverlay();
    });
  }

  fetchHandler(cart, callback) {
    this.cartItemCount(cart);
    var exist_plan_selling = false;
    cart.items.forEach((item, index) => {
      var selling_plan_id = "";
      if (item.selling_plan_allocation) {
        selling_plan_id = item.selling_plan_allocation.selling_plan.id;
        exist_plan_selling = true;
      }
    });

    if (this.isDrawerMode) {
      if (cart.item_count === 0) {
        this.renderBlankCartDrawer();
        this.cartDrawerFooter.classList.add("is-invisible");
        this.annoumentsBar.classList.add("hidden");
      } else {
        this.renderDrawerCart(cart);

        var houndredPercent = 7500;
        var mount = (houndredPercent - cart.total_price) / 100;
        this.annoumentsBar.querySelector(".text-1").textContent =
          cart.total_price > houndredPercent || exist_plan_selling
            ? "Congrats! You've unlocked FREE Shipping!"
            : "$" +
              parseFloat((houndredPercent - cart.total_price) / 100).toFixed(2) +
              " away from a FREE SHIPPING! ";
        this.annoumentsBar.querySelector(".container-bar .bar").style.cssText =
          cart.total_price > houndredPercent || exist_plan_selling
            ? "width: 100%"
            : "width: " + (cart.total_price * 100) / houndredPercent + "%";

        this.annoumentsBar.classList.remove("hidden");

        this.cartDrawerFooter.classList.remove("is-invisible");
        if (typeof callback === "function") {
          callback(cart);
        }
      }
    } else if (cart.item_count === 0) {
      this.renderBlankMiniCart();
      this.cartMiniCartFooter.classList.add("is-invisible");
    } else {
      this.renderMiniCart(cart);
      this.cartMiniCartFooter.classList.remove("is-invisible");
      if (typeof callback === "function") {
        callback(cart);
      }
    }
  }

  addItemToCartHandler(product) {
    return this.displayModal
      ? this.fetchAndOpenModal(product)
      : this.fetchAndOpenCart();
  }

  ajaxRequestFail() {
    this.openFailModal();
    this.openCartOverlay();
  }

  renderCartModal(product) {
    this.clearCartModal();
    let productVariant = product.variant_title;
    if (productVariant === null) {
      productVariant = "";
    } else {
      productVariant = `(${productVariant})`;
    }
    const cartSingleProduct = `
          <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(${
              product.image
            });"></div>
            <div class="go-cart-item__info">
              ${
                product.product_title.includes(this.hiddenItemTag)
                  ? `<p class="go-cart-item__title">${product.product_title} ${productVariant}</p>`
                  : `<a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a>`
              }
              ${this.labelAddedToCart}
            </div>
          </div>`;
    this.cartModalContent.innerHTML += cartSingleProduct;
  }

  renderDrawerCart(cart) {
    this.clearCartDrawer();
    this.clearCartDrawerNotes();
    cart.items.forEach((item, index) => {
      let itemVariant = item.variant_title;
      if (itemVariant === null) {
        itemVariant = "";
      }

      let each_pay = "";
      var selling_plan_id = "";
      if (item.selling_plan_allocation) {
        each_pay = `<span><small>${item.selling_plan_allocation.selling_plan.name}, save 10% on each order</small></span>`;
        selling_plan_id = item.selling_plan_allocation.selling_plan.id;
      }

      const cartSingleProduct = `
            <div class="go-cart-item__single" data-upgradable-item data-line-item-key="${
              item.variant_id
            }" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                  <div class="text-image">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                      ${
                        item.product_tags.includes(this.hiddenItemTag)
                          ? `<p class="go-cart-item__title h4">${item.product_title}</p>`
                          : `<a href="${item.url}" class="h4 go-cart-item__title">${item.product_title}</a>`
                      }
                    </div>
                  </div>

                  <div class="go-cart-item__info">
                    <div class="go-cart-item__variant body1">${itemVariant}</div>
                    ${each_pay}
                    <div data-upgradeable-item data-line-item-product="${
                      item.product_id
                    }" data-line-item-key="${
        item.variant_id
      }" data-line="${Number(
        index + 1
      )}" data-selling-plan="${selling_plan_id}" data-quantity="${
        item.quantity
      }"></div>
                    ${this.subscriptionOptionsText(item)}
                    <div class="go-cart-price-qty body1">
                      <div class="go-cart-item__quantity body1 quantity-form">
                        ${
                          item.product_tags.includes(this.hiddenItemTag)
                            ? ""
                            : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus" role="button" tabindex="0" onkeydown="keyToClick(event);" aria-label="Reduce Quantity"><i class="fa-regular fa-minus"></i></span>`
                        }
                        <input aria-label="Quantity" class="go-cart-item__quantity-number js-go-cart-quantity body1" type="number" value="${
                          item.quantity
                        }" disabled>
                        ${
                          item.product_tags.includes(this.hiddenItemTag)
                            ? ""
                            : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus" role="button" tabindex="0" onkeydown="keyToClick(event);" aria-label="Increase Quantity"><i class="fa-regular fa-plus"></i></span>`
                        }
                      </div>
                      <div class="body2"> <a class="go-cart-item__remove ${
                        this.removeFromCartNoDot
                      }" data-line="${Number(index + 1)}" role="button" tabindex="0" onkeydown="keyToClick(event);">Remove<span class="sr-only"> ${item.product_title} from cart</span></a></div>
                      <div class="go-cart-item__price body3">${formatMoney(
                        item.line_price,
                        this.moneyFormat
                      )}</div>
                    </div>
                  </div>
                </div>
            </div>
            `;
      this.cartDrawerContent.innerHTML += cartSingleProduct;
    });

    // Add Order Note field
    if (this.cartNotes) {
      this.cartDrawerContentNotes.innerHTML += `
            <div class="cart-notes" style="padding-left: 0; padding-right: 0">
                <label for="SideCartNote" class="h3" style="display: block; margin-bottom: 15px">Order notes:</label>
                <div class="d-flex" style="margin-bottom: 7px">
                    <textarea class="body1" name="note" id="SideCartNote" placeholder="Notes about your order" style="width: 100%"></textarea>
                    <button class="update-cart__note js-go-cart-update-note"><span style="pointer-events:none">Save</span></button>
                </div>
                <div class="go-cart-message">Note saved</div>
            </div>
            `;
    }

    let updateCartNote = document.querySelector(
      ".go-cart-drawer__content .update-cart__note"
    );
    if (updateCartNote) {
      updateCartNote.addEventListener("click", () => {
        document
          .querySelector(".js-go-cart-drawer-content").classList.add("show");
        setTimeout(() => {
          document
            .querySelector(".js-go-cart-drawer-content")
            .classList.remove("show");
        }, 5000);

        document
          .querySelector(".js-go-cart-drawer-content-cart-notes").classList.add("show");
        setTimeout(() => {
          document
            .querySelector(".js-go-cart-drawer-content-cart-notes")
            .classList.remove("show");
        }, 5000);

      });
    }

    // Rebuy Widget on Side Cart
    var rebuyContent = document.querySelector(".js-go-cart-rebuy");

    if (rebuyContent) {
      rebuyContent.removeAttribute("hidden");
    }

    this.cartDrawerSubTotal.innerHTML = formatMoney(
      cart.total_price,
      this.moneyFormat
    );
    this.cartDrawerSubTotal.setAttribute(
      "data-cart-total",
      cart.total_price / 100
    );
    this.cartDrawerSubTotal.parentNode.classList.remove("is-invisible");

    const removeFromCart = document.querySelectorAll(this.removeFromCart);
    removeFromCart.forEach((item) => {
      item.addEventListener("click", () => {
        GoCart.removeItemAnimation(item.parentNode);
        const line = item.getAttribute("data-line");
        this.removeItem(line);
      });
    });

    

    let product_id_promo = document.getElementById('product_promo_id').value;

    const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);

      itemQuantityPlus.forEach((item) => {
      item.addEventListener("click", () => {
        const line =
          item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
            "data-line"
          );
          const line_ID =
          item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
            "data-line-item-key"
          );

         
          
          let add_a_product_without_a_promo = 1;
          if(product_id_promo != '0' ){
            if(product_id_promo == line_ID ){
              add_a_product_without_a_promo = 0;
             
              let padre = item.parentNode.parentNode.parentNode.parentNode.parentNode;
              let nuevoHijo = document.createElement('p');
              let espacio = document.createElement('br');
              nuevoHijo.style.color = 'red';
              nuevoHijo.textContent = 'This product can only be purchased once.';
              padre.appendChild(espacio);
              padre.appendChild(nuevoHijo);
  
              if(Number(item.parentNode.querySelector(this.itemQuantity).value) > 1){
                const quantity = 1;
              this.changeItemQuantity(line, quantity);
              }else{
                const quantity =
                Number(item.parentNode.querySelector(this.itemQuantity).value) + add_a_product_without_a_promo;
                this.changeItemQuantity(line, quantity);
              }
            }else{
              const quantity =
              Number(item.parentNode.querySelector(this.itemQuantity).value) + add_a_product_without_a_promo;
              this.changeItemQuantity(line, quantity);
            }
          }else{
            const quantity =
            Number(item.parentNode.querySelector(this.itemQuantity).value) + add_a_product_without_a_promo;
            this.changeItemQuantity(line, quantity);
          }
          const quantity =
          Number(item.parentNode.querySelector(this.itemQuantity).value) + add_a_product_without_a_promo;
          this.changeItemQuantity(line, quantity);
       
      });
    });
    const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
    itemQuantityMinus.forEach((item) => {
      item.addEventListener("click", () => {
        const line =
          item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
            "data-line"
          );
        const quantity =
          Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
        this.changeItemQuantity(line, quantity);
        if (
          Number(item.parentNode.querySelector(this.itemQuantity).value - 1) ===
          0
        ) {
          GoCart.removeItemAnimation(
            item.parentNode.parentNode.parentNode.parentNode.parentNode
          );
        }
      });
    });
    var noteUpdater = document.querySelector(".js-go-cart-update-note");
    if (noteUpdater) {
      noteUpdater.addEventListener("click", (event) => {
        event.preventDefault();
        this.updateCartOrderNote(event.target);
      });
    }
    document.dispatchEvent(
      new CustomEvent("CartUpdated", {
        bubbles: true,
        detail: "",
      })
    );
  }

  renderMiniCart(cart) {
    this.clearMiniCart();
    cart.items.forEach((item, index) => {
      let itemVariant = item.variant_title;
      if (itemVariant === null) {
        itemVariant = "";
      }
      const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(
                index + 1
              )}">
                <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${
                      item.image
                    });"></div>
                    <div class="go-cart-item__info">
                        ${
                          item.product_tags.includes(this.hiddenItemTag)
                            ? `<p class="go-cart-item__title h4">${item.product_title}</p>`
                            : `<a href="${item.url}" class="go-cart-item__title h4">${item.product_title}</a>`
                        }
                        <div class="go-cart-item__variant">${itemVariant}</div>
                        <div class="go-cart-item__quantity">
                          ${
                            item.product_tags.includes(this.hiddenItemTag)
                              ? ""
                              : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus" role="button" tabindex="0" onkeydown="keyToClick(event);" aria-label="Reduce Quantity">-</span>`
                          }
                          <input aria-label="Quantity" class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${
                            item.quantity
                          }" disabled>
                          ${
                            item.product_tags.includes(this.hiddenItemTag)
                              ? ""
                              : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus" role="button" tabindex="0" onkeydown="keyToClick(event);" aria-label="Increase Quantity">+</span>`
                          }
                        </div>
                    </div>
                </div>
                <div class="go-cart-item__price">${formatMoney(
                  item.line_price,
                  this.moneyFormat
                )}</div>
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}" role="button" tabindex="0" onkeydown="keyToClick(event);">${
        this.labelRemove
      }<span class="sr-only"> ${item.product_title} from cart</span></a>
              </div>`;
      this.cartMiniCartContent.innerHTML += cartSingleProduct;
    });
    this.cartMiniCartSubTotal.innerHTML = formatMoney(
      cart.total_price,
      this.moneyFormat
    );
    this.cartMiniCartSubTotal.parentNode.classList.remove("is-invisible");
    console.error("RENDERED");
    document.dispatchEvent(
      new CustomEvent("CartUpdated", { bubbles: true, detail: detail })
    );
    const removeFromCart = document.querySelectorAll(this.removeFromCart);
    removeFromCart.forEach((item) => {
      item.addEventListener("click", () => {
        GoCart.removeItemAnimation(item.parentNode);
        const line = item.parentNode.getAttribute("data-line");
        this.removeItem(line);
      });
    });
    const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
    itemQuantityPlus.forEach((item) => {
      item.addEventListener("click", () => {
        const line =
          item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
            "data-line"
          );
        const quantity =
          Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
        this.changeItemQuantity(line, quantity);
      });
    });
    const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
    itemQuantityMinus.forEach((item) => {
      item.addEventListener("click", () => {
        const line =
          item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
            "data-line"
          );
        const quantity =
          Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
        this.changeItemQuantity(line, quantity);
        if (
          Number(item.parentNode.querySelector(this.itemQuantity).value - 1) ===
          0
        ) {
          GoCart.removeItemAnimation(
            item.parentNode.parentNode.parentNode.parentNode.parentNode
          );
        }
      });
    });
  }

  subscriptionOptionsText(item) {
    if (item.properties && item.properties.shipping_interval_frequency) {
      return `<div class="go-cart-subscription-label">
                Deliver every ${item.properties.shipping_interval_frequency} ${item.properties.shipping_interval_unit_type}
        </div>`;
    } else {
      return "";
    }
  }

  renderBlankCartDrawer() {
    this.cartDrawerSubTotal.parentNode.classList.add("is-invisible");
    this.clearCartDrawer();
    this.cartDrawerContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
    this.clearCartDrawerNotes();
    this.cartDrawerContentNotes.innerHTML = "";

    var rebuyContent = document.querySelector(".js-go-cart-rebuy");
    if (rebuyContent) {
      rebuyContent.setAttribute("hidden", "");
    }
  }

  renderBlankMiniCart() {
    this.cartMiniCartSubTotal.parentNode.classList.add("is-invisible");
    this.clearMiniCart();
    this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
  }

  reloadAjaxContent() {
    this.fetchAndOpenCart();
  }

  clearCartDrawer() {
    this.cartDrawerContent.innerHTML = "";
  }

  clearCartDrawerNotes() {
    this.cartDrawerContentNotes.innerHTML = "";
  }

  clearMiniCart() {
    this.cartMiniCartContent.innerHTML = "";
  }

  clearCartModal() {
    this.cartModalContent.innerHTML = "";
  }

  openCartDrawer() {
    this.cartDrawer.classList.add("is-open");

    const product_id_promo = document.getElementById('product_promo_id').value;
    if(product_id_promo != '0' ){
      review_product_promo(product_id_promo);
    } 
  }

  closeCartDrawer() {
    this.cartDrawer.classList.remove("is-open");
  }

  openMiniCart() {
    this.cartMiniCart.classList.add("is-open");
  }

  closeMiniCart() {
    this.cartMiniCart.classList.remove("is-open");
  }

  openFailModal() {
    this.cartModalFail.classList.add("is-open");
  }

  closeFailModal() {
    this.cartModalFail.classList.remove("is-open");
  }

  openCartModal() {
    this.cartModal.classList.add("is-open");

    this.focusFirstItem();
  }

  closeCartModal() {
    this.cartModal.classList.remove("is-open");
  }

  openCartOverlay() {
    this.cartOverlay.classList.add("is-open");
  }

  closeCartOverlay() {
    this.cartOverlay.classList.remove("is-open");
  }

  static removeItemAnimation(item) {
    item.classList.add("is-invisible");
  }

  setDrawerDirection() {
    this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
  }
  
  focusFirstItem() {
    const cartDrawerItemInfo = document.querySelectorAll('.go-cart-item__info .h4.go-cart-item__title');

    cartDrawerItemInfo[0].focus();
  }
}

//export default GoCart;


function review_product_promo(product_id_promo){
  
  let customer_metafield = document.getElementById('customer_tag').value;

  let Qty = 1;  
  const elementos = document.querySelectorAll('[data-line-item-key]');
  let data = 0;
  const elementosConIDDeseado = Array.from(elementos).filter(elemento => {
  const cartItemKey = elemento.getAttribute('data-line-item-key');
  
  if(cartItemKey.includes(`${product_id_promo}`)){
     
    if(elemento){
       
      if(elemento.children[0]){
          
        if(elemento.children[0].children[1]){
           
          if(elemento.children[0].children[1].children[2]){
              
            let Qty_input = elemento.children[0].children[1].children[2].children[0].children[1];
              
            if (Qty) {
                // Habilita el input para poder cambiar su valor
                Qty_input.disabled = false;
            
                // Cambia el valor del input
                Qty_input.value = 1;
            
                // Deshabilita el input nuevamente si es necesario
                Qty_input.disabled = true;
              } 
            }
          }
        }
      }
      data = product_id_promo;
      return cartItemKey.includes(`${product_id_promo}`);
    }
      
  });

  const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);

      itemQuantityPlus.forEach((item) => {
      const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value);
      console.log(quantity )
    });

  if(customer_metafield == 'purchased_promo'){
    Qty = 0;  
    removeProductFromCart(product_id_promo, Qty);

  }else{
    if (elementosConIDDeseado.length >=  1 ) {
      removeProductFromCart(product_id_promo, Qty);
    }
   
  } 

}

// Función para actualizar el carrito
function updateCart(line, quantity, callback) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: line,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    callback(data);
  })
  .catch(error => console.error('Error actualizando el carrito:', error));
  
}
// Función para eliminar un producto del carrito
function removeProductFromCart(line,Qty) {
  updateCart(line, Qty, function(cart) {
  });
}


